const state = {
    searchFilter: [],
};

const mutations = {
    setSearchFilter(state, searchFilter) {
        state.searchFilter = searchFilter;
    },
};

const actions = {
    async setSearchFilter({ commit }, searchFilter) {
        commit('setSearchFilter', searchFilter);
    },
    async clearSearchFilter({ commit }) {
        commit('setSearchFilter', '');
    },
};

const getters = {
    searchFilter(state) {
        return state.searchFilter || '';
    },
};

export default {
    state,
    mutations,
    actions,
    getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/searchFilter.js